import { convexClient, crossDomainClient } from "@convex-dev/better-auth/client/plugins";
import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { convexSiteUrl } from "./env";

// Auth routes live on the Convex site URL (convex/http.ts). crossDomain keeps the session
// in localStorage because the web app and Electron are on a different origin from Convex.
export const authClient = createAuthClient({
  baseURL: convexSiteUrl,
  plugins: [convexClient(), crossDomainClient(), organizationClient()],
});
